<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content error" role="alertdialog" aria-modal="true">
      <header class="modal-header">
        <div class="modal-icon" aria-hidden="true">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <h3 class="errortitle">{{ title }}</h3>
        <button
          class="modal-close-icon"
          type="button"
          title="Chiudi"
          @click="closeModal"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </header>
      <p class="modal-message">{{ message }}</p>
      <div class="divbutton">
        <button @click="closeModal" class="error-modal-close-button">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleErrorModal", // Un nome descrittivo per il componente
  props: {
    title: {
      type: String,
      default: "Attenzione",
    },
    message: {
      type: String,
      default: "",
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      // Emette un evento per notificare al componente padre di chiudere il modale
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* Stili per l'overlay del modale */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999; /* Assicurati che sia sopra altri elementi */
  background: rgba(34, 34, 34, 0.747) !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Stili per il contenuto del modale */
.modal-content {
  padding: 0;
  width: min(32rem, calc(100% - 2rem));
  max-width: 32rem;
  background: white;
  border: 1px solid #d9dde3;
  border-radius: 8px;
  text-align: left;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.85rem;
  box-sizing: border-box;
  padding: 1.15rem 1.25rem;
  background: #f2f2f1;
  border-bottom: 1px solid #e2e5e9;
}

.modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.45rem;
  height: 2.45rem;
  color: #9f2f2f;
  background: #fff1f1;
  border: 1px solid #f3c7c7;
  border-radius: 50%;
}

.modal-close-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  color: #69707b;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}

.modal-close-icon:hover {
  color: #252a31;
  background: #e8eaee;
}

/* Stile per il messaggio dell'errore */
.modal-message {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #343a40; /* Grigio scuro per il testo */
  white-space: pre-wrap;
  padding: 1.35rem 1.5rem;
}
.divbutton {
  width: 100%;
  padding: 16px 25px;
  box-sizing: border-box;
  border-top: 1px solid #ddd;
  text-align: right;
  background: #fafafa;
}
.error-modal-close-button {
  padding: 10px 20px;
  font-size: 0.875rem;
  font-weight: 700;
  background-color: #939393;
  color: #ffffff;
  border-style: solid;
  border-radius: 0.125rem;
  border-color: #8c8c8c;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
  display: inline-flex;
  align-items: center;
  outline: none;
}

.error-modal-close-button:hover {
  background-color: #7a7a7a; /* Scelta coerente con il blu del bottone */
}
.errortitle {
  margin: 0;
  color: #252a31;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.25;
}
</style>
